import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import { canReadFactoryState } from '../DeviceView/DeviceTable/utils';

const ManageColumnsModalList = (props) => {
  const userPermissions = useSelector((store) => store.data.rolePermissions.permissions);
  const enabledColumns = [];
  const disabledColumns = [];
  const disabledColumnIds = [
    'azimuth_absolute_col',
    'azimuth_mechanical_col',
    'downtilt_absolute_col',
    'downtilt_mechanical_col'
  ];

  Array.isArray(props.tabColumnsList) &&
    props.tabColumnsList.forEach((column) => {
      if (column.disabled || disabledColumnIds.includes(column.id)) {
        disabledColumns.push(column);
      } else {
        // temp: remove protected and factory options
        if (!['protected_col', 'factory_col'].includes(column.id)) {
          enabledColumns.push(column);
        }
      }
    });

  const allColumns = [...enabledColumns, ...disabledColumns];

  return (
    <div id="ManageColumnsModalList" className="ManageColumnsModalList">
      <div id="ManageColumnsModalList_Container" className="ManageColumnsModalList_Container">
        <PerfectScrollbar>
          {allColumns ? (
            allColumns.map((column, idx) => {
              let { disabled, id, selected, uiName } = column;

              let isChecked = props.localCheckList?.[id];
              let isDisabled = false;
              let isDefault = idx === 0;
              let displayString;

              if (disabledColumnIds.includes(id)) {
                isDisabled = true;
                disabled = true;
              }

              if ((id === 'factory_col' && !canReadFactoryState(userPermissions)) || disabled) {
                isDisabled = true;
              }

              if (id === 'factory_col' && !canReadFactoryState(userPermissions)) {
                displayString = `${uiName} (NO PERMISSION)`;
                return null;
              } else if (disabled) {
                displayString = `${uiName} (FUTURE)`;
              } else if (idx === 0) {
                displayString = `${uiName} (DEFAULT)`;
              } else {
                displayString = uiName;
              }

              return (
                <div
                  key={idx}
                  id="ManageColumnsModalList_ItemDiv"
                  className={classnames('ManageColumnsModalList_ItemDiv', {
                    ManageColumnsModalList_ItemDiv_Disabled: isDisabled && !isDefault,
                    ManageColumnsModalList_ItemDiv_Default: isDefault
                  })}
                >
                  <div id="ManageColumnsModalList_Item" className="ManageColumnsModalList_Item">
                    <Checkbox
                      blueCheckbox={true}
                      disabled={isDisabled}
                      default={isDefault}
                      isChecked={isChecked}
                      onChange={(event) => {
                        if (isDisabled || isDefault) return;
                        let newChecked = !isChecked;
                        let newLocalCheckList = JSON.parse(JSON.stringify(props.localCheckList));
                        newLocalCheckList[id] = newChecked;
                        props.setLocalCheckList(newLocalCheckList);
                        event.stopPropagation(); //stop default row click stuff from happening
                      }}
                    />
                    <div
                      id="ManageColumnsModalList_Item_Label"
                      className="ManageColumnsModalList_Item_Label"
                      data-tip={displayString}
                    >
                      {displayString}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div id="ManageColumnsModalList_NoListsCreatedDiv" className="ManageColumnsModalList_NoListsCreatedDiv">
              No column is available.
            </div>
          )}
        </PerfectScrollbar>
      </div>
    </div>
  );
};

export default memo(ManageColumnsModalList);
